let timestampIndex = 0;

const loaded = {};

/**
 * 对js脚本进行异步加载
 * @param  {String} url     请求地址
 * @param  {Object} options 扩展参数，参数内容如下
 *   @param {Object} data 需要传给服务器的参数，
 *   注意：参数会进行encodeURIComponent编码
 *   @param {Number || Boolean} cache 只能是数字类型，如果是false，则不会拼接该参数
 *   @param {Number} timeout jsonp超时时间，默认为60000毫秒
 *   @param {Boolean} reload 是否重新加载 默认为 true，如果是想jquery这样的库文件，可以选择为 false，这样在页面不被刷新前，一个地址只被加载一次。
 */
export default function(
    url,
    { data = {}, cache = `${new Date().valueOf()}${timestampIndex++}`, timeout = 60000, reload = true } = {},
) {
    if (reload === false && loaded[url]) {
        return loaded[url];
    }

    const load = new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            if (reload === false) {
                delete loaded[url];
            }
            reject(new Error(`timeout|请求超时${timeout}`));
        }, timeout);

        // 对参数进行处理
        const params = [];

        // 只支持对象传入
        if (typeof data === 'object') {
            for (const key of Object.keys(data)) {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
            }
        } else {
            reject(new Error('typeError|data必须为一个对象'));

            return;
        }

        if (cache) {
            params.push(`_=${cache}`);
        }

        let fullUrl = '';

        if (url.includes('?')) {
            fullUrl = `${url}&${params.join('&')}`;
        } else {
            fullUrl = `${url}?${params.join('&')}`;
        }

        const insertScript = document.createElement('script');

        insertScript.src = fullUrl;

        insertScript.onload = insertScript.onreadystatechange = function onreadystatechange() {
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                resolve({ type: 'success', msg: '脚本加载成功' });
                clearTimeout(timer);
                insertScript.onload = insertScript.onreadystatechange = null;
                const head = document.getElementsByTagName('head')[0];

                if (head) {
                    head.removeChild(insertScript);
                }
            }
        };

        insertScript.onerror = function onerror() {
            if (reload === false) {
                delete loaded[url];
            }
            clearTimeout(timer);
            reject(new Error(`loadScriptError|脚本加载错误:${url}`));
        };

        const head = document.getElementsByTagName('head')[0];

        if (head) {
            head.appendChild(insertScript);
        }
    });

    if (reload === false && !loaded[url]) {
        loaded[url] = load;
    }

    return load;
}
